import React, { Fragment, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import { Info } from "feather-icons-react/build/IconComponents";
import { Controller, useForm } from "react-hook-form";
import InputField from "../../components/Input";
import CategoryServices from "../../../services/Category";
import { ErrorToaster } from "../../components/toaster/Toaster";
import { Select } from 'antd';
import { v4 as uuidv4 } from 'uuid'

const CategoryForm = ({ onSubmit, loading }) => {

  const route = all_routes;
  const { id } = useParams();

  const { register, handleSubmit, formState: { errors }, setValue, control } = useForm();

  // *For Variants
  const [variants, setVariants] = useState([{ id: uuidv4() }]);

  // *For Add Variation
  const addVariant = async () => {
    try {
      const updateVariants = [...variants]
      let obj = { id: uuidv4() }
      updateVariants.push(obj)
      setVariants(updateVariants)
    } catch (error) {
      console.log('addVariant => error:', error)
    }
  }

  // *For Delete Variant
  const deleteVariant = (id) => {
    try {
      const index = variants.findIndex((e) => e.id === id)
      let updateVariants = [...variants]
      updateVariants.splice(index, 1);
      setVariants(updateVariants)
    } catch (error) {
      console.log('deleteVariant => error:', error)
    }
  }

  // *For Submit Form
  const submitForm = async (formData) => {
    try {
      const staticOptions = {};

      Object.entries(formData).forEach(([key, value]) => {
        if (key.startsWith("key_")) {
          const id = key.replace("key_", "");
          const variantKey = String(value).replace(/\s+/g, '_');
          const variantValue = formData[`value_${id}`];

          if (Array.isArray(variantValue) && variantKey) {
            staticOptions[variantKey] = variantValue;
          }
        }
      });
      let obj = {
        name: formData?.name,
        remarks: formData?.remarks,
        is_active: formData?.status,
        staticOptions: staticOptions
      }
      console.log('obj', obj)
      onSubmit(obj)
    } catch (error) {
      ErrorToaster(error)
    }
  }

  // *For Get Product Detail
  const getCategoryDetail = async () => {
    try {
      const { data } = await CategoryServices.getCategoryById(id)
      setValue('name', data[0]?.name)
      setValue('remarks', data[0]?.remarks)
      setValue('status', data[0]?.is_active)

      const options = [];
      const keyValues = [];
      Object.entries(data[0]?.static_options).forEach(([key, value]) => {
        const optionId = uuidv4();
        options.push({ id: optionId });
        keyValues.push({ optionId, key, value });
      })
      setVariants(options)

      setTimeout(() => {
        keyValues.forEach(({ optionId, key, value }) => {
          setValue(`key_${optionId}`, key);
          setValue(`value_${optionId}`, value);
        });
      }, 10);
    } catch (error) {
      ErrorToaster(error)
    }
  }

  useEffect(() => {
    if (id) {
      getCategoryDetail()
    }
  }, [id]);

  return (
    <form onSubmit={handleSubmit(submitForm)}>
      <div className="card">
        <div className="card-body add-product pb-0">
          <div className="mb-3">
            <div className="addproduct-icon">
              <h5>
                <Info className="add-info" />
                <span>Information</span>
              </h5>
            </div>
            <div className="row align-items-center">
              <div className="col-lg-3 col-sm-3 col-6">
                <div className="mb-3 add-product">
                  <InputField
                    label="Name"
                    type="text"
                    error={errors?.name?.message}
                    register={register("name", {
                      required: 'Please enter product name.',
                    })}
                  />
                </div>
              </div>
              <div className="col-lg-6 col-sm-6 col-12">
                <div className="mb-3 add-product">
                  <InputField
                    label="Remarks"
                    inputType="textarea"
                    placeholder="Type Remarks"
                    register={register("remarks")}
                  />
                </div>
              </div>
              <div className="col-lg-6 col-sm-6 col-6">
                <div className="status-toggle modal-status d-flex justify-content-between align-items-center">
                  <span className="status-label">Status</span>
                  <InputField
                    id="checkbox1"
                    type="checkbox"
                    className="check"
                    defaultChecked={true}
                    register={register("status")}
                  />
                </div>
              </div>
              <div className="col-lg-12 col-sm-12 col-12 mt-3">
                <h3>Static Options</h3>
              </div>
              {variants?.length > 0 &&
                variants.map((item, index) => (
                  <Fragment key={index}>
                    <div className="col-lg-3 col-sm-3 col-3 mt-2">
                      <div className="mb-3">
                        <InputField
                          label={`Option ${index + 1}`}
                          type="text"
                          register={register(`key_${item?.id}`)}
                        />
                      </div>
                    </div>
                    <div className="col-lg-8 col-sm-8 col-3 mt-2">
                      <div className="mb-3">
                        <label className="form-label">{`Value ${index + 1}`}</label>
                        <Controller
                          control={control}
                          name={`value_${item?.id}`}
                          render={({ field }) => (
                            <Select
                              {...field}
                              mode="tags"
                              style={{ width: '100%' }}
                              options={[]}
                              onChange={(value) => field.onChange(value)}
                              value={field.value || []}
                            />
                          )}
                        />
                      </div>
                    </div>
                    {variants.length > 1 &&
                      <div className="col-lg-1 col-sm-1 col-3 mt-2">
                        <p className="text-danger text-center" style={{ cursor: 'pointer' }} onClick={() => deleteVariant(item?.id)}>Remove</p>
                      </div>
                    }
                  </Fragment>
                ))
              }
              <div className="col-lg-3 col-sm-3 col-3 mt-2">
                <button
                  type="button"
                  className="btn btn-submit"
                  onClick={() => addVariant()}
                >
                  Add Option
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-12">
        <div className="btn-addproduct mb-4">
          <Link to={route.products} className="btn btn-cancel me-2">
            Cancel
          </Link>
          <button
            type="submit"
            className="btn btn-submit"
            disabled={loading}
          >
            Submit
          </button>
        </div>
      </div>
    </form>
  );
};

export default CategoryForm;
